import { StringEntityIdenifier } from "../entity.v2/entity-identifier";

export interface MyTeamsEntity {
  /** the list of teams for this account */
  teams: Team[];
}

export interface Team {
  /** Id of the team. */
  Id: string;

  /** Name of the team. */
  Name: string;

  /** Support area paths assigned to team */
  SupportAreaPaths: string[];

  /** List of leads for the team. */
  TeamLeads: string[];

  /** List of manager for the team. */
  TeamManagers: string[];

  /** List of AgentIds for the team. */
  AgentIds: string[];
}

export class MyTeamsIdentifier extends StringEntityIdenifier {
  constructor(id: string) {
    super();
    this.id = id;
  }
}

/** model for teams as returned by agent service call*/
export interface TeamServiceModel {
  /** Id of the site this team bellong to. */
  SiteId: string;

  /** Name of the site this team bellong to. */
  SiteName: string;

  /** Id of the supplier this team bellong to. */
  SupplierId: string;

  /** Name of the supplier this team bellong to. */
  SupplierName: string;

  /** Unknown. */
  TimeZoneId: string;

  /** List of agent in the team. */
  AgentIds: string[];

  /** List of area path supported by the team. */
  SupportAreaPaths: string[];

  /** List of leads for the team. */
  TeamLeads: string[];

  /** List of manager for the team. */
  TeamManagers: string[];

  /** The locales supported by the team. */
  SupportedLocales: string[];

  /** Unknown. */
  HoursOfOperation: WorkingHour[];

  /** Unknown. */
  RoutingContexts: string[];

  /** Unique ID for the team. */
  id: string;

  /** Name of the team. */
  Name: string;

  /** The time when team was created. */
  CreatedDateTime: string;

  /** The time when team was last modified. */
  LastModifiedDateTime: string;

  /** The user who created the team. */
  CreatedBy: string;

  /** The user who last modified the team. */
  LastModifiedBy: string;

  /** States if the team is in active role. */
  IsActive: boolean;

  /** Unknown. */
  VersionNumber: string;

  /** Unknown. */
  Type: string;
}

export interface WorkingHour {
  /** Unknown. */
  Start: string;

  /** Unknown. */
  End: string;

  /** Unknown. */
  DayOfWeek: string;
}
